import { z } from 'zod';
// ── Tele-consultation (SRS 11.1) ─────────────────────────────────────────────
export const TELE_STATUS = ['scheduled', 'waiting', 'in_progress', 'completed', 'cancelled', 'no_show'];
export const createTeleSchema = z.object({
    patientId: z.string().uuid(),
    doctorId: z.string().uuid(),
    appointmentId: z.string().uuid().nullable().optional(),
    scheduledAt: z.string().datetime(),
    /** An external provider is recorded, never called from here. */
    provider: z.enum(['internal', 'zoom', 'meet', 'whatsapp']).default('internal'),
    notes: z.string().max(2000).optional(),
});
export const teleStatusSchema = z.object({
    status: z.enum(TELE_STATUS),
    notes: z.string().max(2000).optional(),
});
//# sourceMappingURL=tele.js.map